import { getViteAppEsrBaseUrl } from './Vite/getViteAppEsrBaseUrl';
import { getViteAppEsrWssUrl } from './Vite/getViteAppEsrWssUrl';

/** WebSocket URL prefix before the token segment (AppSync realtime). Mocked in Jest setup. */
export function getEsrRealtimeGraphqlUrlPrefix(): string {
  return `${getViteAppEsrWssUrl()}/graphql/realtime?header=`;
}

/** `host` value sent in subscription auth extensions. Mocked in Jest setup. */
export function getEsrGraphqlHostForSubscription(): string {
  return getViteAppEsrBaseUrl();
}
